import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@material-ui/core';

const ProcessCancel = ({ student, loading, onConfirm, disabled }) => {
    const handleConfirm = () => {
        onConfirm(student);
    };

    return (
        <Box>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Se cancelará la membresía del alumno <strong>{student.name} {student.last_name}</strong> ({student.email}).
                Esta acción no se puede deshacer.
            </Typography>
            <Box mt={3}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirm}
                    disabled={disabled || loading}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? 'Procesando...' : 'Confirmar Baja'}
                </Button>
            </Box>
        </Box>
    );
};

export default ProcessCancel;
